import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Color, Loading } from "../domain";
import { ColorsRepository } from "../domain/repositories/colors-repository";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type ColorsState = {
  colors: Color[];
  loading: Loading;
};

const initialState: ColorsState = {
  colors: [],
  loading: "idle",
};

const colorsSlice = createSlice({
  name: "colors",
  initialState,
  reducers: {
    colorsLoading(state) {
      state.loading = "pending";
    },
    colorsLoaded(state, { payload }: PayloadAction<Color[]>) {
      state.colors = payload;
      state.loading = "succeeded";
    },
    colorsFailed(state) {
      state.loading = "failed";
    },
  },
});

export default colorsSlice.reducer;

const { colorsFailed, colorsLoaded, colorsLoading } = colorsSlice.actions;

export const loadColors = (): AppThunk => async (dispatch) => {
  dispatch(colorsLoading());
  const res = await ServiceLocater.get<ColorsRepository>(
    Services.ColorsRepository
  ).list();
  res.fold(
    (_) => {
      dispatch(colorsFailed());
    },
    (r) => {
      dispatch(colorsLoaded(r));
    }
  );
};
